var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4B87C9Caec649B370Fa3657Bd55A804(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#bd1723",
    height: 128.8,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 459.3 128.8",
    width: 459.3,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.9,128.8H64.4C28.8,128.8,0,100,0,64.4v0C0,28.8,28.8,0,64.4,0l330.5,0c35.6,0,64.4,28.8,64.4,64.4v0 C459.3,100,430.4,128.8,394.9,128.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4B87C9Caec649B370Fa3657Bd55A804);
export default __webpack_public_path__ + "static/media/f4b87c9caec649b370fa3657bd55a804.1eb457206cba2b0bb0a2b52a48521b34.svg";
export { ForwardRef as ReactComponent };